import { useCallback } from 'react';

export type UserModalViewProps = {
  totalItems: number;
  limit: number;
};

const useAdditionalHeight = ({ totalItems, limit }: UserModalViewProps) => {
  const additionalHeight = useCallback(() => {
    return totalItems <= limit ? '275px' : '211px';
  }, [totalItems, limit]);

  return additionalHeight;
};

export default useAdditionalHeight;
